var map = {
	"./en": [
		98881,
		8881
	],
	"./en.ts": [
		98881,
		8881
	],
	"./id": [
		69667,
		9667
	],
	"./id.ts": [
		69667,
		9667
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 39701;
module.exports = webpackAsyncContext;